import ltdInfo1 from '@/assets/charts/ltd-info-1.png';

const info = [
    {
        tag: 'h1',
        content: 'Распределение времени выполнения',
    },
    {
        tag: 'p',
        content: `График LTD показывает для выбранного периода распределение дней,
        за которые ваши задачи проходят путь от момента создания до завершения.`,
    },
    {
        tag: 'p',
        content: 'Благодаря пониманию количества задач решаемых за определенное количество дней, вы можете:',
    },
    {
        tag: 'ul',
        childs: [
            {
                tag: 'li',
                content: 'Анализировать эффективность выполнения задач и определять зоны оптимизации ваших процессов;',
            },

            {
                tag: 'li',
                content: 'Прогнозировать количество времени, которое потребуется для завершения новой задачи.',
            },
        ],
    },
    {
        tag: 'br',
    },
    {
        tag: 'h2',
        content: 'Как устроен график LTD',
    },
    {
        tag: 'img',
        attributes: {
            src: ltdInfo1,
        },
    },
    {
        tag: 'ul',
        childs: [
            {
                tag: 'li',
                content: 'По оси X расположены дни',
            },

            {
                tag: 'li',
                content: 'По оси Y - количество решенных задач',
            },
        ],
    },
    {
        tag: 'p',
        content: 'На приведенном графике можно заметить, что за 4 дня было выполнено 8 задач, а за 10 дней - 2 задачи',
        attributes: {
            style: {
                backgroundColor: 'yellow',
                display: 'inline',
            },
        },
    },
    {
        tag: 'br',
    },
    {
        tag: 'h2',
        content: 'Интерпретация графика',
    },
    {
        tag: 'p',
        content: 'На графике присутствуют следующие основные зоны:',
    },
    {
        tag: 'ul',
        childs: [
            {
                tag: 'li',
                content: 'Сосредоточение большей части решенных задач;',
            },

            {
                tag: 'li',
                content: 'Хвосты справа.',
            },
        ],
    },
    {
        tag: 'p',
        content: `В зависимости от специфики вашей компании, основная часть решенных
        задач может быть в левой части графика, или близка к середине. В ней
        сосредоточены “типичные” задачи, с которыми сталкивается ваша команда.`,
    },
    {
        tag: 'p',
        content: `Чем более узкая зона с основной частью задач,
        тем стабильнее протекают процессы разработки.`,
    },
    {
        tag: 'p',
        content: `Чем выше столбцы на графике у хвостов справа и чем длиннее ось X,
        тем непостоянней время выполнения задач, что может сигнализировать о повышенной
        сложности данных задач или о связи с различными факторами, такими как блокировка
        задачи или изменения требований/переделки задач.`,
    },
    {
        tag: 'p',
        content: `В идеальной ситуации гистограмма должна показывать
        в основном более высокие столбцы с левой стороны.`,
    },
    {
        tag: 'p',
        content: `Если у вашего графика LTD наблюдается сильный хвост, рекомендуется
        проанализировать задачи с большим сроком выполнения и разработать меры для снижения выбросов в хвосте.`,
    },
    {
        tag: 'br',
    },
    {
        tag: 'h2',
        content: 'Прогнозирование сроков выполнения задач',
    },
    {
        tag: 'p',
        content: `Поскольку график демонстрирует уже решенные вашей командой задачи,
        то на основе предыдущих данных, вы можете спрогнозировать вероятность срока
        выполнения для новой задачи.`,
    },
    {
        tag: 'p',
        content: 'Для прогнозирования используются процентили выполненных задач.',
    },
    {
        tag: 'p',
        content: 'Рассмотрим пример для графика LTD для решенных за последний квартал задач:',
    },
    {
        tag: 'ul',
        childs: [
            {
                tag: 'li',
                content: '50% задач было решено за 2 дня или меньше;',
            },
            {
                tag: 'li',
                content: '85% задач было решено за 7 дней или меньше;',
            },
            {
                tag: 'li',
                content: '95% задач было решено за 18 дней или меньше.',
            },
        ],
    },
    {
        tag: 'p',
        content: `Соответственно, при поступлении новой задачи, можно сказать, что
        с 95% вероятностью команда будет решать до 18 дней, а с 85% вероятностью задача
        будет решена за 7 дней или меньше.`,
    },
];

export default {
    info: JSON.stringify(info),
    for: 'за',
    quantity: 'Кол-во',
    days: 'Дни',
    issues: 'Задачи',
};
